import { FeatureCardsProps } from '@/assets/content/products/type'
import Icon from '@/components/icon'
import styles from './style.module.scss'

type ContentProps = FeatureCardsProps['content']

export default function CardList({ content }: { content: ContentProps }) {
  return (
    <div className={styles.cardList}>
      {content.map(item => (
        <div className={styles.card} key={item.title}>
          <Icon name={item.icon} className={styles.icon} />
          <div className={styles.cardTitle}>{item.title}</div>
          <div>
            {item.description.map(desc => (
              <div className={styles.cardDescription} key={desc}>
                {desc}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
